(function () {
  'use strict';

  var qs = function (s, c) { return (c || document).querySelector(s); };
  var qsa = function (s, c) { return [].slice.call((c || document).querySelectorAll(s)); };
  var body = document.body;
  var cartType = body.getAttribute('data-cart-type');

  function setMenu(open) {
    var m = qs('[data-menu]'); if (!m) return;
    m.hidden = !open; body.classList.toggle('no-scroll', open);
    var b = qs('[data-menu-open]'); if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function drawer() { return qs('[data-cart-drawer]'); }

  function openDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    body.classList.add('no-scroll');
    var c = qs('[data-cart-close]', d);
    if (c) c.focus();
  }

  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    body.classList.remove('no-scroll');
  }

  function paintDrawer(sections) {
    var d = drawer();
    if (!d || !sections || !sections['cart-drawer']) return;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = qs('[data-cart-drawer]', doc);
    if (fresh) d.innerHTML = fresh.innerHTML;
  }

  function paintCount(n) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !n;
    });
  }

  function refreshCart(openAfter) {
    return fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        paintDrawer(s);
        return fetch('/cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        paintCount(c.item_count);
        if (openAfter) openDrawer();
      });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;

    if (!f.matches ||
        !f.matches('form[data-ajax-cart]') ||
        cartType !== 'drawer' ||
        !drawer()) return;

    e.preventDefault();

    var btn = qs('[type="submit"]', f);
    if (btn) btn.disabled = true;

    var fd = new FormData(f);
    fd.append('sections', 'cart-drawer');

    fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json'
      }
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.status && j.description) {
          alert(j.description);
          return;
        }

        paintDrawer(j.sections);

        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (c) {
            paintCount(c.item_count);
            openDrawer();
          });
      })
      .catch(function () {
        f.submit();
      })
      .then(function () {
        if (btn) btn.disabled = false;
      });
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest(
      '[data-menu-open],' +
      '[data-menu-close],' +
      '[data-search-open],' +
      '[data-search-close],' +
      '[data-cart-link],' +
      '[data-cart-close],' +
      '[data-line-qty],' +
      '[data-line-remove]'
    );

    if (!t) return;

    if (t.matches('[data-menu-open]')) {
      setMenu(true);
    }

    else if (t.matches('[data-menu-close]')) {
      setMenu(false);
    }

    else if (t.matches('[data-search-open]')) {
      var dlg = qs('[data-search]');

      if (dlg && dlg.showModal) {
        dlg.showModal();
        var i = qs('input', dlg);
        if (i) i.focus();
      }
    }

    else if (t.matches('[data-search-close]')) {
      var d2 = qs('[data-search]');
      if (d2) d2.close();
    }

    else if (t.matches('[data-cart-link]')) {
      if (cartType === 'drawer' && drawer()) {
        e.preventDefault();
        refreshCart(true);
      }
    }

    else if (t.matches('[data-cart-close]')) {
      closeDrawer();
    }

    else if (t.matches('[data-line-qty],[data-line-remove]')) {
      e.preventDefault();

      var line = t.getAttribute('data-line');
      var qty = t.hasAttribute('data-line-remove')
        ? 0
        : parseInt(t.getAttribute('data-qty'), 10);

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          line: parseInt(line, 10),
          quantity: qty,
          sections: 'cart-drawer'
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          paintDrawer(c.sections);
          paintCount(c.item_count);
        });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      setMenu(false);
    }
  });

  qsa('[data-rotator]').forEach(function (el) {
    var items = qsa('[data-rotator-item]', el);

    if (items.length < 2) return;

    var i = 0;
    var speed = (parseInt(el.getAttribute('data-speed'), 10) || 5) * 1000;

    setInterval(function () {
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }, speed);
  });

  qsa('[data-slider]').forEach(function (s) {
    var track = qs('[data-slider-track]', s);
    var slides = qsa('[data-slide]', s);
    var dots = qsa('[data-dot]', s);

    if (!track || slides.length < 2) return;

    var i = 0;
    var timer;

    function go(n) {
      i = (n + slides.length) % slides.length;

      track.scrollTo({
        left: slides[i].offsetLeft,
        behavior: 'smooth'
      });
    }

    dots.forEach(function (d, n) {
      d.addEventListener('click', function () {
        go(n);
      });
    });

    track.addEventListener('scroll', function () {
      var n = Math.round(track.scrollLeft / track.clientWidth);

      if (n !== i && n >= 0 && n < slides.length) {
        i = n;
      }

      dots.forEach(function (d, k) {
        d.setAttribute(
          'aria-current',
          k === i ? 'true' : 'false'
        );
      });
    }, { passive: true });

    var speed = (parseInt(s.getAttribute('data-speed'), 10) || 0) * 1000;

    var reduce =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function start() {
      if (speed && !reduce) {
        timer = setInterval(function () {
          go(i + 1);
        }, speed);
      }
    }

    function stop() {
      clearInterval(timer);
    }

    s.addEventListener('mouseenter', stop);
    s.addEventListener('mouseleave', start);
    s.addEventListener('focusin', stop);
    s.addEventListener('focusout', start);

    start();
  });

  qsa('select[data-default]').forEach(function (sel) {
    var v = sel.getAttribute('data-default');
    if (v) sel.value = v;
  });

  qsa('[data-auto-submit]').forEach(function (el) {
    el.addEventListener('change', function () {
      if (el.form) el.form.submit();
    });
  });

  /* Bundle + quantity + gallery + ingredient explorer + countdown for product page (hf) */
  qsa('.hf').forEach(function (root) {

    var $ = function (s) {
      return root.querySelector(s);
    };

    var $$ = function (s) {
      return [].slice.call(root.querySelectorAll(s));
    };

    /* Gallery */
    var stageImg = $('[data-stage-img]');

    $$('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {

        $$('[data-thumb]').forEach(function (o) {
          o.setAttribute('aria-current', 'false');
        });

        t.setAttribute('aria-current', 'true');

        if (stageImg) {
          stageImg.removeAttribute('srcset');
          stageImg.src = t.dataset.full;
        }
      });
    });

    /* Bundle pricing */
    var variantInput = $('[data-variant-input]');
    var priceNow = $('[data-price-now]');
    var priceWas = $('[data-price-was]');
    var priceSave = $('[data-price-save]');
    var atcPrice = $('[data-atc-price]');
    var stagePrice = $('[data-sticky-price]');
    var stageTag = $('[data-stage-tag]');

    $$('input[name="bundle"]').forEach(function (r) {
      r.addEventListener('change', function () {

        if (variantInput) variantInput.value = r.value;

        if (priceNow) priceNow.textContent = r.dataset.price;

        if (atcPrice) atcPrice.textContent = r.dataset.price;

        if (stagePrice) stagePrice.textContent = r.dataset.price;

        var hasSave = r.dataset.was && +r.dataset.off > 0;

        if (priceWas) {
          priceWas.textContent = r.dataset.was;
          priceWas.hidden = !hasSave;
        }

        if (priceSave) {
          priceSave.textContent = 'Save ' + r.dataset.off + '%';
          priceSave.hidden = !hasSave;
        }

        if (stageTag) {
          stageTag.textContent = 'Save ' + r.dataset.off + '%';
          stageTag.hidden = !hasSave;
        }
      });
    });

    /* Quantity */
    var qty = $('[data-qty]');
    var qtyInput = $('[data-qty-input]');
    var n = 1;

    function setQty(v) {
      n = Math.max(1, Math.min(10, v));

      if (qty) qty.textContent = n;
      if (qtyInput) qtyInput.value = n;
    }

    var plus = $('[data-plus]');
    var minus = $('[data-minus]');

    if (plus) {
      plus.addEventListener('click', function () {
        setQty(n + 1);
      });
    }

    if (minus) {
      minus.addEventListener('click', function () {
        setQty(n - 1);
      });
    }

    /* Sticky ATC */
    var atc = $('[data-atc]');
    var sticky = $('[data-sticky]');

    if (atc && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        sticky.classList.toggle(
          'show',
          !e[0].isIntersecting &&
          e[0].boundingClientRect.top < 0
        );
      }).observe(atc);
    }

    /* Ingredient Explorer */
    $$('[data-explorer]').forEach(function (ex) {

      var tabs = [].slice.call(
        ex.querySelectorAll('[data-explorer-tab]')
      );

      var panels = [].slice.call(
        ex.querySelectorAll('.hf-explorer-panel')
      );

      tabs.forEach(function (tab, i) {

        tab.addEventListener('click', function () {

          tabs.forEach(function (t) {
            t.setAttribute('aria-selected', 'false');
          });

          panels.forEach(function (p) {
            p.hidden = true;
          });

          tab.setAttribute('aria-selected', 'true');

          if (panels[i]) {
            panels[i].hidden = false;
          }
        });

      });

    });

    /* Countdown */
    $$('[data-countdown]').forEach(function (el) {

      var end = new Date(
        el.getAttribute('data-countdown')
      ).getTime();

      var out = el.querySelector('[data-countdown-text]');

      function tick() {

        var diff = end - Date.now();

        if (diff <= 0 || !out) {
          if (out) out.textContent = 'ended';
          return;
        }

        var h = Math.floor(diff / 3600000);
        var m = Math.floor(
          (diff % 3600000) / 60000
        );
        var s = Math.floor(
          (diff % 60000) / 1000
        );

        out.textContent =
          h + 'h ' +
          m + 'm ' +
          s + 's';

        requestAnimationFrame(function () {
          setTimeout(tick, 1000);
        });
      }

      tick();

    });

  });

})();